var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbAmenityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 0H5.55556V2.66667L7.56667 4.27778C7.7 4.37778 7.77778 4.54444 7.77778 4.71111V9.44444C7.77778 9.75556 7.53333 10 7.22222 10H2.77778C2.46667 10 2.22222 9.75556 2.22222 9.44444V4.71111C2.22222 4.54444 2.3 4.37778 2.43333 4.27778L4.44444 2.66667V0H0V11.1111C0 13.5667 1.98889 15.5556 4.44444 15.5556H11.1111C13.5667 15.5556 15.5556 13.5667 15.5556 11.1111V7.77778H17.7778C18.3671 7.77778 18.9324 7.54365 19.3491 7.1269C19.7659 6.71016 20 6.14493 20 5.55556V2.22222C20 0.988889 19.0111 0 17.7778 0ZM17.7778 5.55556H15.5556V2.22222H17.7778V5.55556Z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 17.7778H0V20.0001H17.7778V17.7778Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbAmenityIcon);
export default __webpack_public_path__ + "static/media/SBAmenityIcon.eec917fa0b1401859206e3686227ab8c.svg";
export { ForwardRef as ReactComponent };